export function extractSortKey(sortKey: string) {
    if (!sortKey) return;
    const [corp, office] = sortKey.split("#");
    const corpPrefix = corp?.replace("corp_", "");
    const officeCd = office?.replace("office_", "");
    return {
        corpPrefix,
        officeCd
    }
}